import React from 'react';
import { useParams } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { SectionLabel, SectionHeading } from '../components/ui/UI';
export function TopicPage() {
  const {
    topicId
  } = useParams();
  // Format topicId (e.g., "automated-security-validation" -> "Automated Security Validation")
  const formattedTitle = topicId ? topicId.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'Security Topic';
  return <>
      <PageHero eyebrow="Security Topics" title={formattedTitle} titleMuted="" description={`Learn about ${formattedTitle} and how Periscan fits into this category.`} bg="none" data-id="element-1803" />

      <SectionStage fx="matrix" data-id="element-1804">
        <section className="relative w-full py-32 border-t border-white/5" data-id="element-1805">
          <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1806">
            <SectionLabel number="01" label="Overview" className="mb-8" data-id="element-1807" />
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1808">
              <div className="lg:col-span-8" data-id="element-1809">
                <SectionHeading size="xl" data-id="element-1810">
                  Understanding
                  <br data-id="element-1811" />
                  <span className="text-white/40" data-id="element-1812">{formattedTitle}.</span>
                </SectionHeading>
              </div>
            </div>
            <div className="mt-12 max-w-3xl text-lg text-white/60 leading-relaxed" data-id="element-1813">
              <p data-id="element-1814">
                This page explains the category plainly and details how Periscan
                fits.
              </p>
            </div>
          </div>
        </section>
      </SectionStage>
    </>;
}